import { useAnalyticsDashboardEmbedInfo } from "@/hooks/use-analytics-dashboard-embed-info";
import { DashboardEmbedPage } from "./dashboard-embed-page";

interface AnalyticsDashboardProps {
  theme: "dark" | "light";
}

export function AnalyticsDashboardPage(props: AnalyticsDashboardProps) {
  const embedInfoQuery = useAnalyticsDashboardEmbedInfo();

  return (
    <DashboardEmbedPage
      description="View ad campaign performance"
      embedInfoQuery={embedInfoQuery}
      theme={props.theme}
      title="Analytics"
    />
  );
}
